import DashboardLayout from 'src/pages/Layout/DashboardLayout.vue'
// GeneralViews
import NotFound from 'src/pages/NotFoundPage.vue'
// Dashboard pages
import Overview from 'src/pages/Dashboard/Overview.vue'
// Pages
import Login from 'src/pages/Login.vue'
// Stories
import Stories from 'src/pages/Stories/Stories.vue'
import Story from 'src/pages/Stories/Story.vue'
import StoryThumbnails from 'src/pages/Stories/StoryThumbnails.vue'
import StoryEditor from 'src/pages/Stories/StoryEditor.vue'
// Authors
import Authors from 'src/pages/Authors/Authors.vue'
import Author from 'src/pages/Authors/Author.vue'
// Tags
import Tags from 'src/pages/Tags/Tags.vue'
import Tag from 'src/pages/Tags/Tag.vue'
// Authors
import Topics from 'src/pages/Topics/Topics.vue'
import Topic from 'src/pages/Topics/Topic.vue'
// Home
import Home from 'src/pages/Home/Home.vue'

const routes = [
  {
    path: '/',
    meta: { auth: true },
    redirect: '/admin/overview',
    component: DashboardLayout,
    children: [
      {
        name: 'Overview',
        path: '/admin/overview',
        meta: { auth: true },
        component: Overview
      },
      {
        name: 'Home',
        path: '/admin/home',
        meta: {
          auth: true,
          title: 'Composition de la une',
          class: 'fa fa-th-large'
        },
        component: Home
      },
      {
        path: '/admin/stories',
        name: 'stories',
        meta: {
          auth: true,
          title: 'Liste des articles',
          class: 'fa fa-file-text-o'
        },
        component: Stories,
        beforeEnter: (to, from, next) => {
          if (to.query.display) {
            to.query.display = JSON.parse(to.query.display)
          }
          next()
        }
      },
      {
        path: '/admin/stories/:id',
        name: 'story',
        meta: {
          auth: true,
          title: 'Article',
          class: 'fa fa-file-text-o'
        },
        component: Story,
        beforeEnter: (to, from, next) => {
          if (to.query.edit) {
            to.query.edit = JSON.parse(to.query.edit)
          }
          next()
        }
      },
      {
        path: '/admin/stories/:id/thumbnails',
        name: 'story_thumbnails',
        meta: {
          auth: true,
          title: 'Images d’illustration',
          class: 'fa fa-picture-o'
        },
        component: StoryThumbnails
      },
      {
        path: '/admin/stories/:id/editor',
        name: 'story_editor',
        meta: {
          auth: true,
          title: 'Modifier le contenu',
          class: 'fa fa-edit'
        },
        component: StoryEditor
      },
      {
        path: '/admin/authors',
        name: 'authors',
        meta: {
          auth: true,
          title: 'Liste des rédacteurs',
          class: 'fa fa-users'
        },
        component: Authors,
        beforeEnter: (to, from, next) => {
          if (to.query.display) {
            to.query.display = JSON.parse(to.query.display)
          }
          next()
        }
      },
      {
        path: '/admin/authors/:id',
        name: 'author',
        meta: {
          auth: true,
          title: 'Rédacteur',
          class: 'fa fa-user'
        },
        component: Author,
        beforeEnter: (to, from, next) => {
          if (to.query.edit) {
            to.query.edit = JSON.parse(to.query.edit)
          }
          next()
        }
      },
      {
        path: '/admin/tags',
        name: 'tags',
        meta: {
          auth: true,
          title: 'Liste des tags et catégories',
          class: 'fa fa-tags'
        },
        component: Tags,
        beforeEnter: (to, from, next) => {
          if (to.query.display) {
            to.query.display = JSON.parse(to.query.display)
          }
          next()
        }
      },
      {
        path: '/admin/tags/:id',
        name: 'tag',
        meta: {
          auth: true,
          title: 'Tag',
          class: 'fa fa-tag'
        },
        component: Tag,
        beforeEnter: (to, from, next) => {
          if (to.query.edit) {
            to.query.edit = JSON.parse(to.query.edit)
          }
          next()
        }
      },
      {
        path: '/admin/topics',
        name: 'topics',
        meta: {
          auth: true,
          title: 'Liste des dossiers',
          class: 'fa fa-folder-o'
        },
        component: Topics,
        beforeEnter: (to, from, next) => {
          if (to.query.display) {
            to.query.display = JSON.parse(to.query.display)
          }
          next()
        }
      },
      {
        path: '/admin/topics/:id',
        name: 'topic',
        meta: {
          auth: true,
          title: 'Dossier',
          class: 'fa fa-folder-o'
        },
        component: Topic,
        beforeEnter: (to, from, next) => {
          if (to.query.edit) {
            to.query.edit = JSON.parse(to.query.edit)
          }
          next()
        }
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {path: '*', component: NotFound}
]

export default routes
